import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageUsers/Profile/SocialAccounts/Views/social-accounts-profile.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {SocialMediaModel} from '@/Pages/Admin/Modules/Models/CompanySettings/SocialMediaModel';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';

@WithRender
@Component({
    components: {
        'validation-error': ValidationError,
    }
})
export default class SocialAccountsProfile extends Vue {
    private ui: any = {};
    protected item: any = {};
    protected vars: any = {};

    constructor() {
        super();

        this.ui = {
            index: {
                edit: -1,
                delete: -1,
            },
            status: {
                isLoading: {
                    socialMediaList: false,
                    socialMediaIconList: false,
                },
                postLoading: {
                    saveSocialMedia: false,
                    editSocialMedia: false,
                    deleteSocialMedia: false,
                },
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    delete: {},
                },
            },
        };

        this.item = {
            socialMediaData: new SocialMediaModel({}),
            editsocialMediaData: new SocialMediaModel({}),
            deleteSocialMediaData: new SocialMediaModel({}),
            tempData: new SocialMediaModel({}),
            socialMediaList: new SocialMediaModel({}),
            socialMediaIconList: [],
        };
    }

    public created() {
        this.getAllSocialMediaList();
        this.getAllSocialMediaIconList();
    }

    public customLabel(name: any) {
        return name;
    }

    public async getAllSocialMediaList() {
        this.ui.status.isLoading.socialMediaList = true;
        trekService
            .getSocialMediaList({})
            .then((res: any) => {
                res.data.data.filter((icon: any) => {
                    icon.IsActive = false;
                });
                this.item.socialMediaList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then((res: any) => {
                    this.ui.error.error_message = res;
                    this.ui.error.has_error = true;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.socialMediaList = false;
            });
    }

    public async getAllSocialMediaIconList() {
        this.ui.status.isLoading.socialMediaIconList = true;
        let data = {};
        trekService
            .getSocialMedia()
            .then((res: any) => {
                this.item.socialMediaIconList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then((res: any) => {
                    this.ui.error.error_message = res;
                    this.ui.error.has_error = true;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.socialMediaIconList = false;
            });
    }

    // save the social account
    public async saveSocialAccount() {
        this.resetError();

        if (!this.validateSaveSocialAccountAction()) {
            return;
        }
        this.ui.status.postLoading.saveSocialMedia = true;
        let data = {
            social_media_id: this.item.socialMediaData.social_media.id,
            link: this.item.socialMediaData.link,
        };
        trekService
            .postSocialMediaAccount(data)
            .then((res: any) => {
                this.item.socialMediaList.unshift(res.data.data);
                this.item.socialMediaData = new SocialMediaModel({});
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.saveSocialMedia = false;
            });
    }

    public validateSaveSocialAccountAction() {
        if (!this.item.socialMediaData.link) {
            Object.assign(this.ui.error.errors, {
                link: ['The link field is required.']
            });
        }
        if (!this.item.socialMediaData.social_media || this.item.socialMediaData.social_media.id === 0) {
            Object.assign(this.ui.error.errors, {
                social_media: ['The social media field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    //  edit the social account
    public async onEditSocialAccountClick(social: any, index: any) {
        this.resetError();
        social.IsActive = true;
        this.ui.status.canEdit = true;
        this.ui.index.edit = index;
        this.item.tempData = Object.assign({}, social);
        this.item.editsocialMediaData = social;
    }


    public async onCancelSocialAccountClick(social: any, index: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        this.item.tempData.IsActive = false;
        this.item.socialMediaList[index] = this.item.tempData;
    }

    public async saveEditedSocialAccount() {
        this.resetError();

        if (!this.validateEditSocialAccountAction()) {
            return;
        }
        let data = {
            social_media_id: this.item.editsocialMediaData.social_media.id,
            id: this.item.editsocialMediaData.id,
            link: this.item.editsocialMediaData.link,
        };
        this.ui.status.postLoading.editSocialMedia = true;
        trekService
            .editSocialMedia(data)
            .then((res: any) => {
                this.$set(this.item.socialMediaList, this.ui.index.edit, res.data.data);
                this.ui.status.canEdit = false;
                flashService.Success('Social Account Edited', res.data.message);
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.canEdit = false;
                this.ui.status.postLoading.editSocialMedia = false;
            });
    }

    public validateEditSocialAccountAction() {
        let list = this.item.editsocialMediaData;
        if (!list.link) {
            Object.assign(this.ui.error.errors, {
                edit_link: ['The link field is required.']
            });
        }
        if (list.social_media === null || list.social_media.id === 0) {
            Object.assign(this.ui.error.errors, {
                edit_social_media: ['The social media field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }


    protected onDeleteSocialAccountClick(index: any, list: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        $('#deleteSocialAccount').modal('show');
        this.ui.index.delete = index;
        this.item.deleteSocialMediaData = list;
    }

    protected hideDeleteModal() {
        $('#deleteSocialAccount').modal('hide');
        $('.modal-backdrop').remove();
        this.ui.error.modal.delete = {};
        this.resetError();
    }

    // delete the social account
    public async deleteSocialAccount() {
        this.ui.status.postLoading.deleteSocialMedia = true;
        let data = {
            id: this.item.deleteSocialMediaData.id,
        };
        trekService
            .deleteSocialMedia(data)
            .then((res: any) => {
                this.$delete(this.item.socialMediaList, this.ui.index.delete);
                flashService.Success('Social Account Deleted', res.data.message);
                this.hideDeleteModal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.modal.delete).then(res => {
                    this.ui.error.modal.delete = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.deleteSocialMedia = false;
            });
    }


    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}
